/**
 * Interface for device v3 fetching parameters
 *//**
 * Service for managing app v3 devices with consistent naming to devices-legacy
 */export class DevicesLegacyV3Service{// eslint-disable-next-line no-useless-constructor
constructor(api){this.api=api;}/**
   * Get V3 devices with parameters matching devices-legacy pattern
   * Note: This endpoint returns a simple array of devices, not a paginated collection
   */async getDevices(_ref){let{appName}=_ref;const url=`/api/v3/devices?appName=${appName}`;return this.api.get(url);}}